<template>
  <div class="app-auto-top-up">
    <div v-if="!insideModal">
      <div v-if="topUp.type === 'monthly'">
        <form>
          <fieldset class="inputs-container">
            <div class="input-field ">
              <label for="monthly-amount" class="text-sm"><slot name="lblMonthlyAmount">Betrag in Euro</slot></label>
              <select class="input" id="monthly-amount" v-model="inputMonthly" required>
                <option :value="o.value" :key="index" v-for="(o, index) in monthlyOptions">
                  {{ o.text }}
                </option>
              </select>
            </div>
          </fieldset>
        </form>
      </div>
      <div v-if="topUp.type === 'byLimit'">
        <form>
          <fieldset class="inputs-container flex-row">
            <div class="input-field full-width">
              <label for="trigger-amount" class="text-sm"><slot name="lblByLimitFirst">Betrag in Euro</slot></label>
              <select class="input" id="trigger-amount" v-model="inputTrigger" required>
                <option :value="o.value" :key="index" v-for="(o, index) in triggerOptions">
                  {{ o.text }}
                </option>
              </select>
            </div>
            <div class="input-field full-width">
              <label for="threshold-amount" class="text-sm"><slot name="lblByLimitSecond">Betrag in Euro</slot></label>
              <select class="input" id="threshold-amount" v-model="inputThreshold" required>
                <option :value="o.value" :key="index" v-for="(o, index) in thresholdOptions">
                  {{ o.text }}
                </option>
              </select>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
    <div v-else>
      <form class="content-limiter">
        <div class="inputs-container">
          <div class="radio-group radio-flex">
            <label style="align-items: flex-start;">
              <input
                type="radio"
                name="selectedAutoTopUp"
                v-model="selectedAutoTopUp"
                :value="{ active: false, amount: undefined, trigger: undefined, type: null }"
              /><span class="custom-radio"></span>
              <div style="display: flex; flex-direction: column; gap: .75rem;">
                <span class="text-base">keine automatische Aufladung</span>
                <div>
                  <p>Dein LIDL Connect Guthaben wird <strong>nicht automatisch aufgeladen</strong></p>
                </div>
              </div>
            </label>
            <label style="align-items: flex-start;">
              <input type="radio" name="selectedAutoTopUp" :value="valueMonthly" v-model="selectedAutoTopUp" /><span
                class="custom-radio"
              ></span>
              <div style="display: flex; flex-direction: column; gap: .5rem;">
                <span class="text-base">Monatliche Aufladung</span>
                <p>Dein LIDL Connect Guthaben wird automatisch monatlich jeweils am 02. des Monats aufgeladen.</p>
                <div>
                  <form>
                    <fieldset class="inputs-container">
                      <div class="input-field full-width">
                        <label for="monthly-amount" class="text-base">Aufladebetrag</label>
                        <select class="input" id="monthly-amount" v-model="inputMonthly" required>
                          <option :value="o.value" :key="index" v-for="(o, index) in monthlyOptions">
                            {{ o.text }}
                          </option>
                        </select>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </label>
            <label style="align-items: flex-start;">
              <input type="radio" name="selectedAutoTopUp" :value="valueByLimit" v-model="selectedAutoTopUp" /><span
                class="custom-radio"
              ></span>
              <div style="display: flex; flex-direction: column; gap: .5rem;">
                <span class="text-base">Guthabengesteuerte Aufladung</span>
                <p>Dein LIDL Connect Guthaben wird automatisch aufgeladen, wenn es unter einen bestimmten Betrag fällt.</p>
                <div>
                  <form>
                    <fieldset class="inputs-container flex-row">
                      <div class="input-field full-width">
                        <label for="trigger-amount" class="text-base"><slot name="lblByLimitFirst">Guthabengrenze</slot></label>
                        <select class="input" id="trigger-amount" v-model="inputTrigger" required>
                          <option :value="o.value" :key="index" v-for="(o, index) in triggerOptions">
                            {{ o.text }}
                          </option>
                        </select>
                      </div>
                      <div class="input-field full-width">
                        <label for="threshold-amount" class="text-base"
                          ><slot name="lblByLimitSecond">Aufladebetrag</slot></label
                        >
                        <select class="input" id="threshold-amount" v-model="inputThreshold" required>
                          <option :value="o.value" :key="index" v-for="(o, index) in thresholdOptions">
                            {{ o.text }}
                          </option>
                        </select>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </label>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'
import price from '@/mixins/price'

export default {
  name: 'AutoTopUp',
  data() {
    return {
      topUpAmounts_: {
        autoAmounts: {
          threshold: {
            amount: [],
            trigger: []
          },
          monthly: {
            amount: []
          }
        }
      }
    }
  },
  methods: {
    buildOptions(optionList) {
      const me = this
      return optionList.map(function(option) {
        return {
          value: option,
          text: me.price(option)
        }
      })
    }
  },
  watch: {
    selectedAutoTopUp: {
      immediate: true,
      handler: function(value) {
        this.$emit('update:trigger', value.trigger)
        this.$emit('update:amount', value.amount)
      }
    }
  },
  computed: {
    topUpAmounts: {
      get() {
        if (this.insideActivation) {
          return this.topUpAmountsStore
        } else {
          return this.topUpAmounts_
        }
      },
      set(value) {
        this.topUpAmounts_ = value
      }
    },
    ...mapGetters('activation/info', {
      topUpAmountsStore: 'topUpAmounts'
    }),
    ...mapGetters(['brand']),
    selectedAutoTopUp: {
      get: function() {
        if (this.topUp) {
          if (this.topUp.type === 'monthly') {
            return Object.assign({}, this.topUp, { amount: this.inputMonthly })
          }
          if (this.topUp.type === 'byLimit') {
            return Object.assign({}, this.topUp, { amount: this.inputThreshold }, { trigger: this.inputTrigger })
          }
          return this.topUp
        }
        return {}
      },
      set: function(value) {
        this.$emit('update-top-up', value)
      }
    },
    valueMonthly() {
      return { ...this.topUp, type: 'monthly', trigger: 2 }
    },
    valueByLimit() {
      return { ...this.topUp, type: 'byLimit' }
    },
    defaultTrigger: function() {
      if (this.topUp.type === 'byLimit' && this.topUp.trigger !== null) {
        const comp = this
        const otherTrigger = this.monthlyValue.find(function(option) {
          return option === comp.topUp.trigger
        })
        if (typeof otherTrigger === 'undefined') {
          return this.topUp.trigger
        }
      }
      return this.topUpAmounts.autoAmounts.threshold.defaultTrigger
    },
    defaultThreshold: function() {
      if (this.topUp.type === 'byLimit' && this.topUp.amount !== null) {
        return this.topUp.amount
      }
      return this.topUpAmounts.autoAmounts.threshold.default
    },
    defaultMonthly: function() {
      if (this.topUp.type === 'monthly' && this.topUp.amount !== null) {
        return this.topUp.amount
      }
      return this.topUpAmounts.autoAmounts.monthly.default
    },
    triggerOptions: function() {
      return this.buildOptions(this.topUpAmounts.autoAmounts.threshold.trigger)
    },
    thresholdOptions: function() {
      return this.buildOptions(this.topUpAmounts.autoAmounts.threshold.amount)
    },
    monthlyOptions: function() {
      return this.buildOptions(this.topUpAmounts.autoAmounts.monthly.amount)
    }
  },
  mixins: [
    preFilledInput('inputTrigger', 'defaultTrigger'),
    preFilledInput('inputMonthly', 'defaultMonthly'),
    preFilledInput('inputThreshold', 'defaultThreshold'),
    price
  ],
  props: {
    topUp: {
      type: Object
    },
    monthlyValue: {
      type: Array
    },
    insideActivation: {
      type: Boolean,
      default: false
    },
    insideModal: {
      type: Boolean,
      default: false
    }
  },
  apollo: {
    topUpAmounts: function() {
      return wrapQuery(
        gql`
          query($brand: String!) {
            topUpAmounts(brand: $brand) {
              autoAmounts {
                monthly {
                  amount
                  default
                }
                threshold {
                  amount
                  default
                  defaultTrigger
                  trigger
                }
              }
            }
          }
        `,
        this,
        'topUpAmounts',
        {
          brand: this.brand
        },
        null,
        {
          fetchPolicy: 'cache-first',
          skip: this.insideActivation
        }
      )
    }
  }
}
</script>
